import { render, staticRenderFns } from "./DashboardKeyAccount.vue?vue&type=template&id=ed4f27c2"
import script from "./DashboardKeyAccount.vue?vue&type=script&lang=js"
export * from "./DashboardKeyAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports